import { withKeys as _withKeys, withModifiers as _withModifiers, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent } from "vue"
import _imports_0 from '@/app/ui/assets/svg/ics_o_close.svg'
import _imports_1 from '@/app/ui/assets/svg/exclamation-triangle-red.svg'


const _hoisted_1 = {
  key: 0,
  ref: "root",
  "data-testid": "booking-v4-client-field-client",
  class: "relative w-full"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: "",
  class: "w-3 h-3"
}, null, -1)
const _hoisted_3 = {
  key: 0,
  "data-testid": "booking-v4-client-field-client-error",
  class: "mt-1 text-xs text-red-lp-100 flex items-center gap-2 text-14px"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "w-4.5 max-w-none",
  alt: ""
}, null, -1)
const _hoisted_5 = {
  key: 1,
  ref: "mainResults",
  class: "absolute left-0 right-0 mt-1 bg-white border border-gray-lp-1400 rounded-md overflow-auto shadow-lg",
  style: {"z-index":"20","max-height":"193px"}
}
const _hoisted_6 = {
  key: 0,
  class: "p-2 flex flex-col gap-2"
}
const _hoisted_7 = {
  key: 2,
  class: "px-3 py-4 text-sm text-gray-lp-600"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_DaftarKlienPopupV4 = _resolveComponent("DaftarKlienPopupV4")!

  return (_ctx.showPicker)
    ? (_openBlock(), _createBlock("section", _hoisted_1, [
        _createVNode("div", {
          "data-testid": 
        _ctx.selectedClient ? 'booking-v4-client-field-client-chip' : undefined
      ,
          class: ["flex items-center border rounded-md bg-white", [
        _ctx.errorMessage ? 'border-red-lp-100' : 'border-gray-lp-400',
        _ctx.isDisabled
          && 'text-gray-lp-600 cursor-not-allowed bg-gray-lp-1500'
      ]]
        }, [
          _createVNode("input", {
            ref: "trigger",
            "data-testid": "booking-v4-client-field-client-select",
            class: ["flex-1 px-3 py-2 text-sm outline-none bg-transparent", _ctx.errorMessage && 'border-red-lp-100'],
            value: _ctx.fieldValue,
            readonly: false,
            disabled: _ctx.isDisabled,
            placeholder: _ctx.$t('bookingV4.client.fieldPlaceholder'),
            onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onMainSearchInput && _ctx.onMainSearchInput(...args))),
            onFocus: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onMainFocus && _ctx.onMainFocus(...args))),
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onMainClick && _ctx.onMainClick(...args))),
            onBlur: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onMainBlur && _ctx.onMainBlur(...args))),
            onKeydown: [
              _cache[5] || (_cache[5] = _withKeys(
//@ts-ignore
(...args) => (_ctx.closeMainResults && _ctx.closeMainResults(...args)), ["esc"])),
              _cache[6] || (_cache[6] = _withKeys(
//@ts-ignore
(...args) => (_ctx.onMainTab && _ctx.onMainTab(...args)), ["tab"])),
              _cache[7] || (_cache[7] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.onTriggerArrowDown && _ctx.onTriggerArrowDown(...args)), ["prevent"]), ["down"])),
              _cache[8] || (_cache[8] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.onTriggerArrowUp && _ctx.onTriggerArrowUp(...args)), ["prevent"]), ["up"]))
            ]
          }, null, 42, ["value", "disabled", "placeholder"]),
          (_ctx.selectedClient && !_ctx.isDisabled)
            ? (_openBlock(), _createBlock("button", {
                key: 0,
                type: "button",
                "data-testid": "booking-v4-client-field-client-chip-clear",
                class: "p-2",
                "aria-label": _ctx.$t('bookingV4.client.clear'),
                onMousedown: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["prevent"])),
                onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.clearSelection && _ctx.clearSelection(...args)))
              }, [
                _hoisted_2
              ], 40, ["aria-label"]))
            : _createCommentVNode("", true),
          (!_ctx.isDisabled)
            ? (_openBlock(), _createBlock("button", {
                key: 1,
                type: "button",
                "data-testid": "booking-v4-client-field-client-open-list",
                class: "px-3 py-2 text-xs font-semibold text-red-lp-2400",
                disabled: _ctx.isDisabled,
                onMousedown: _cache[11] || (_cache[11] = _withModifiers(() => {}, ["prevent"])),
                onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.openList && _ctx.openList(...args)))
              }, _toDisplayString(_ctx.$t("bookingV4.client.openList")), 41, ["disabled"]))
            : _createCommentVNode("", true)
        ], 10, ["data-testid"]),
        (_ctx.errorMessage)
          ? (_openBlock(), _createBlock("p", _hoisted_3, [
              _hoisted_4,
              _createTextVNode(" " + _toDisplayString(_ctx.errorMessage), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.showMainResults)
          ? (_openBlock(), _createBlock("div", _hoisted_5, [
              (_ctx.isInitialLoading)
                ? (_openBlock(), _createBlock("div", _hoisted_6, [
                    (_openBlock(), _createBlock(_Fragment, null, _renderList(3, (index) => {
                      return _createVNode(_component_Skeleton, {
                        key: index,
                        height: "32px"
                      })
                    }), 64))
                  ]))
                : (_openBlock(true), _createBlock(_Fragment, { key: 1 }, _renderList(_ctx.clients, (client, index) => {
                    return (_openBlock(), _createBlock("button", {
                      key: client.clientCode,
                      ref: 
          (el) => {
            if (el) _ctx.mainResultButtons[index] = el;
          }
        ,
                      type: "button",
                      class: "block w-full text-left px-3 py-2 text-sm hover:bg-gray-lp-700 focus:bg-gray-lp-700 focus:outline-none",
                      onMousedown: _withModifiers(($event: any) => (_ctx.selectClient(client)), ["prevent"]),
                      onKeydown: [
                        _withKeys(_withModifiers(($event: any) => (_ctx.onResultArrowDown(index)), ["prevent"]), ["down"]),
                        _withKeys(_withModifiers(($event: any) => (_ctx.onResultArrowUp(index)), ["prevent"]), ["up"]),
                        _withKeys(_withModifiers(($event: any) => (_ctx.selectClient(client)), ["prevent"]), ["enter"]),
                        _cache[13] || (_cache[13] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.closeMainResults && _ctx.closeMainResults(...args)), ["prevent"]), ["esc"]))
                      ]
                    }, _toDisplayString(_ctx.clientLabel(client)), 41, ["onMousedown", "onKeydown"]))
                  }), 128)),
              (!_ctx.isInitialLoading && !_ctx.clients.length)
                ? (_openBlock(), _createBlock("p", _hoisted_7, _toDisplayString(_ctx.$t("bookingV4.client.notFound")), 1))
                : _createCommentVNode("", true)
            ], 512))
          : _createCommentVNode("", true),
        _createVNode(_component_DaftarKlienPopupV4, {
          visible: _ctx.popupVisible,
          clients: _ctx.clients,
          origins: _ctx.origins,
          selectedOrigin: _ctx.selectedOrigin,
          selectedServiceTypes: _ctx.selectedServiceTypes,
          serviceTypeOptions: _ctx.serviceTypeOptions,
          searchKeyword: _ctx.searchKeyword,
          isInitialLoading: _ctx.isInitialLoading,
          isLoadingMore: _ctx.isLoadingMore,
          hasNextPage: _ctx.hasNextPage,
          listErrorMessage: _ctx.listErrorMessage,
          selectedClient: _ctx.selectedClient,
          isOriginLoading: _ctx.isOriginLoading,
          originsHasNextPage: _ctx.originsHasNextPage,
          onClose: _ctx.closeList,
          "onUpdate:search": _ctx.updateSearch,
          "onUpdate:origin": _ctx.updateOrigin,
          "onUpdate:serviceTypes": _ctx.updateServiceTypes,
          onOriginFocus: _cache[14] || (_cache[14] = ($event: any) => (_ctx.$emit('origin-focus'))),
          onOriginFilter: _cache[15] || (_cache[15] = ($event: any) => (_ctx.$emit('origin-filter', $event))),
          onOriginScrolled: _cache[16] || (_cache[16] = ($event: any) => (_ctx.$emit('origin-scrolled', $event))),
          onReset: _ctx.resetFilters,
          onLoadMore: _cache[17] || (_cache[17] = ($event: any) => (_ctx.$emit('load-more'))),
          onSelect: _ctx.selectClient,
          onRetry: _cache[18] || (_cache[18] = ($event: any) => (_ctx.$emit('retry')))
        }, null, 8, ["visible", "clients", "origins", "selectedOrigin", "selectedServiceTypes", "serviceTypeOptions", "searchKeyword", "isInitialLoading", "isLoadingMore", "hasNextPage", "listErrorMessage", "selectedClient", "isOriginLoading", "originsHasNextPage", "onClose", "onUpdate:search", "onUpdate:origin", "onUpdate:serviceTypes", "onReset", "onSelect"])
      ], 512))
    : _createCommentVNode("", true)
}